import React from "react";

interface IProps {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  title?: string;
  className?: string;
  variant?: "blue" | "emerald" | "red" | "gray" | string;
}

export function EBadge({
  label,
  isActive,
  onClick,
  title,
  className = "",
  variant = "blue",
}: IProps) {
  // If onClick is provided, it's an interactive pill
  if (onClick) {
    const basePillClasses =
      "px-3 py-1 rounded-full text-xs font-semibold border transition-all duration-150 cursor-pointer select-none";

    const activeStyles: Record<string, string> = {
      blue: "bg-blue-600 text-white border-blue-600 shadow-sm",
      emerald: "bg-emerald-600 text-white border-emerald-600 shadow-sm",
    };

    const inactiveStyles: Record<string, string> = {
      blue: "bg-white text-gray-500 border-gray-300 hover:border-blue-400 hover:text-blue-600 hover:bg-blue-50",
      emerald:
        "bg-white text-gray-500 border-gray-300 hover:border-emerald-400 hover:text-emerald-600 hover:bg-emerald-50",
    };

    const styleKey = activeStyles[variant] ? variant : "blue";
    const stateClasses = isActive
      ? activeStyles[styleKey]
      : inactiveStyles[styleKey];

    return (
      <button
        type="button"
        title={title || label}
        onClick={onClick}
        className={[basePillClasses, stateClasses, className].join(" ")}
      >
        {label}
      </button>
    );
  }

  // Otherwise, it's a static badge (maintaining backward compatibility)
  // Note: variant can be a tailwind color like "green-600" for static badges
  const isNamedVariant = ["blue", "emerald", "red", "gray"].includes(variant);
  const badgeClass = `badge ${isNamedVariant ? `bg-${variant}-50 border-${variant}-200` : `bg-${variant}`
    } p-0.5 px-1 border rounded-md ${className}`;
  const labelClass = `label font-bold text-xs ${isNamedVariant ? `text-${variant}-700` : `text-${variant}`
    }`;

  return (
    <div className={badgeClass} title={title}>
      <div className={labelClass}>{label}</div>
    </div>
  );
}
